var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-end f-w3",attrs:{"id":"dot"}},_vm._l((_vm.total),function(i){return _c('div',{key:i,staticClass:"dot-item"},[_c('div',{staticClass:"dot-item-view",class:i === _vm.index ? 'active' : ''})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }